import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { ITireAlertSetting, defaultValue } from 'app/shared/model/tire-alert-setting.model';

const initialState: EntityState<ITireAlertSetting> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/tire-alert-settings';

export const getEntities = createAsyncThunk(
  'tireAlertSetting/fetch_entity',
  async () => {
    return axios.get<ITireAlertSetting>(apiUrl);
  }
);

export const updateEntity = createAsyncThunk(
  'tireAlertSetting/update_entity',
  async (entity: ITireAlertSetting) => {
    return axios.put<ITireAlertSetting>(
      `${apiUrl}/${entity.id}`,
      cleanEntity(entity)
    );
  },
  { serializeError: serializeAxiosError }
);

export const restoreDefault = createAsyncThunk(
  'tireAlertSetting/restore_default',
  async () => {
    return axios.put<ITireAlertSetting>(
      `${apiUrl}-restore-default`
    );
  },
  { serializeError: serializeAxiosError }
);

export const TireAlertSettingSlice = createEntitySlice({
  name: 'tireAlertSetting',
  initialState,

  extraReducers(builder) {
    builder
      .addMatcher(
        isFulfilled(getEntities, updateEntity, restoreDefault),
        (state, action) => {
          state.loading = false;
          state.updating = false;
          state.updateSuccess = true;
          state.entity = action.payload.data;
          state.entities = [action.payload.data];
        }
      )
      .addMatcher(
        isPending(getEntities, restoreDefault),
        state => {
          state.errorMessage = null;
          state.updateSuccess = false;
          state.loading = true;
        }
      )
      .addMatcher(
        isPending(updateEntity),
        state => {
          state.errorMessage = null;
          state.updateSuccess = false;
          state.updating = true;
        }
      );
  },
});

export const { reset } = TireAlertSettingSlice.actions;

export default TireAlertSettingSlice.reducer;